// extracted by mini-css-extract-plugin
module.exports = {"controls":"confirmation-dialog_controls__20Rt6","controlsButton":"confirmation-dialog_controlsButton__1XjSw","message":"confirmation-dialog_message__dnq6Y"};